import { useParams } from 'react-router';
import { ApprovalsPanel } from '../components/ApprovalsPanel';
import { ContentSkeleton } from '../components/ContentSkeleton';
import { RunHeader } from '../components/RunHeader';
import { useEvalSetStatus } from '../hooks/useEvalSetStatus';
import { isTerminal } from '../types/monitoring';

export default function EvalSetApprovalsPage() {
  const { evalSetId } = useParams<{ evalSetId: string }>();
  const result = useEvalSetStatus({ evalSetId: evalSetId ?? null });

  return (
    <div className="pane flex flex-col md:h-full md:overflow-hidden">
      <RunHeader evalSetId={evalSetId ?? ''} current="approvals" />
      <div className="md:min-h-0 md:flex-1 md:overflow-y-auto">
        {result.state === 'loading' && (
          <div className="p-4">
            <ContentSkeleton message="Loading approvals…" />
          </div>
        )}
        {result.state === 'error' && (
          <p className="p-4 text-sm text-err">{result.message}</p>
        )}
        {result.state === 'ready' && (
          <ApprovalsPanel
            key={result.data.job_id}
            jobId={result.data.job_id}
            pendingCount={result.data.pending_interactions ?? 0}
            active={!isTerminal(result.data.status)}
            tasks={result.data.tasks ?? []}
          />
        )}
      </div>
    </div>
  );
}
